import React, {useEffect} from "react";
import {connect} from "react-redux";
import SiteContainer from "components/homepage/SiteContainer";
import "react-toastify/dist/ReactToastify.css";
import * as SiteActions from "actions/SiteActions";
import getStaticFile from "utils/getStaticFile";

const headerBackgroundImage = getStaticFile("img/instructors_bg.jpg");

function EventsPage(props) {
    useEffect(() => {
        props.loadPublicEvents();
    }, []);

    return (
        <SiteContainer
            headerImage={headerBackgroundImage}
            tagLine={<span>Classes & Events</span>}
            shorter
        >
            {props.children}
        </SiteContainer>
    );
}

export default connect((state, ownProps) => ({
        events: state.site.events,
    }),
    (dispatch) => ({
        loadPublicEvents: () => dispatch(SiteActions.loadPublicEvents())
    })
)(EventsPage);
